import React, { Component } from 'react';
import { Form, Input, Button, Row, Col, Alert, Select } from 'antd';
import { connect } from 'react-redux';
import * as actions from '../redux/actions/employee';

class CreateForm extends Component {
    state = {
        name: "",
        username: "",
        password: "",
        message: "",
        role: [],
    }
    layout = {
        labelCol: {
            span: 8,
        },
        wrapperCol: {
            span: 16,
        },
    };
    tailLayout = {
        wrapperCol: {
            offset: 8,
            span: 16,
        },
    };

    onFinish = async (values) => {
        console.log('Success:', values);
        await this.props.onCreate({
            name: this.state.name,
            username: this.state.username,
            password: this.state.password,
            roles: this.state.role
        }, this.props.token);
    };

    onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    handleNameChange = (e) => {
        this.setState(prevState => {
            return {
                ...prevState,
                name: e.target.value
            }
        });
    }
    handleUsernameChange = (e) => {
        this.setState(prevState => {
            return {
                ...prevState,
                username: e.target.value
            }
        });
    }
    handlePasswordChange = (e) => {
        this.setState(prevState => {
            return {
                ...prevState,
                password: e.target.value
            }
        });
    }
    handleChangeSelect = (v) => {
        this.setState(prevState => {
            return {
                ...prevState,
                role: [v.value],
            }
        });
    }
    render() {
        const { Option } = Select;
        let alert = null;
        if (this.props.error) {
            alert = (<Form.Item label="Status"><Alert message={this.props.error} type="error" showIcon /></Form.Item>);
        }
        if(this.props.message){
            alert=(<Form.Item label="Status"><Alert message={this.props.message} type="success" showIcon /></Form.Item>);
        }
        const roles = this.props.roles.map(role => {
            return (
                <Option key={role.id} value={role.id}>{role.name}</Option>
            );
        })
        return (
            <Row justify="left" align="middle">
                <Col lg={8} sm={20}>
                    <Form
                        {...this.layout}
                        name="basic"
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                    >
                        {alert}
                        <Form.Item
                            label="Name"
                            name="name"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your name!',
                                },
                                { min: 4, message: 'Name must be minimum 4 characters.' },
                            ]}
                        >
                            <Input onChange={this.handleNameChange} autoComplete="off"/>
                        </Form.Item>
                        <Form.Item
                            label="Username"
                            name="cname"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your username!',
                                },
                                { min: 4, message: 'Username must be minimum 4 characters.' },
                            ]}
                        >
                            <Input onChange={this.handleUsernameChange} autoComplete="off"/>
                        </Form.Item>
                        <Form.Item
                            name="cpass"
                            label="Password"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your password!',
                                },
                                { min: 6, message: 'Password must be minimum 6 characters.' },
                            ]}
                            hasFeedback
                        >
                            <Input.Password onChange={this.handlePasswordChange} />
                        </Form.Item>

                        <Form.Item
                            name="confirm"
                            label="Confirm Password"
                            dependencies={['cpass']}
                            hasFeedback
                            rules={[
                                {
                                    required: true,
                                    message: 'Please confirm your password!',
                                },
                                ({ getFieldValue }) => ({
                                    validator(rule, value) {
                                        if (!value || getFieldValue('cpass') === value) {
                                            return Promise.resolve();
                                        }

                                        return Promise.reject('The two passwords that you entered do not match!');
                                    },
                                }),
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>
                        <Form.Item
                            name="roles"
                            label="Roles"
                            rules={
                                [{
                                    required: true,
                                    message: 'Require role',
                                }]
                            }
                        >
                            <Select
                                labelInValue
                                style={{ width: 180 }}
                                onChange={this.handleChangeSelect}
                            >
                                {roles}
                            </Select>
                        </Form.Item>
                        <Form.Item {...this.tailLayout}>
                            <Button type="primary" htmlType="submit">
                                Create
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        );
    }

};
const mapStateToProps = state => {
    return {
        token: state.auth.token,
        error: state.employee.error,
        message:state.employee.message,
        roles: state.roles.roles,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onCreate: (employee, token) => dispatch(actions.createEmployee(employee, token)),
        onGet: (token) => dispatch(actions.getEmployees(token)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateForm);